<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link :to="{name: 'profiles'}">Veterinarian profiles</router-link></li>
        <li class="breadcrumb-item active">{{ record.clinic }} - {{ record.doctor }}</li>
      </ol>
    </div>
    <form
      v-if="$store.state.permissions.create.vet_profiles"
      action="/api/admin/profiles/save"
      method="POST"
      @submit.prevent="saveRecord()"
    >
      <div class="card">
        <div class="card-header">
          <h3 class="page-title">Edit profile #{{ record.id }}</h3>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3>Clinic information</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Clinic</label>
                <input
                  :class="{ 'is-invalid': $v.record.clinic.$error }"
                  v-model.trim="record.clinic"
                  class="form-control"
                  @input="$v.record.clinic.$touch()"
                >
                <div v-if="$v.record.clinic.$error">
                  <span
                    v-if="!$v.record.clinic.required"
                    class="help-block help-block-error"
                  >Field is required</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Fax</label>
                <input v-mask="'(###) ###-####'" v-model.trim="record.fax"
                       placeholder="(999) 999-9999" class="form-control" >
              </div>
              <div class="form-group">
                <label>Address</label>
                <input v-model.trim="record.address" placeholder="Street Address" class="form-control" >
              </div>
              <div class="form-group">
                <label>City</label>
                <input v-model.trim="record.city" placeholder="City" class="form-control" >
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Phone</label>
                <input v-mask="'(###) ###-####'" v-model.trim="record.phone"
                       placeholder="(999) 999-9999" class="form-control" >
              </div>
              <div class="form-group">
                <label>State</label>
                <input v-model.trim="record.state" placeholder="State" class="form-control" >
              </div>
              <div class="form-group">
                <label>ZIP</label>
                <input v-mask="getZipMask(record.zip)" v-model.trim="record.zip" placeholder="77000" class="form-control" >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3>Doctor information</h3>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Doctor</label>
                <input
                  :class="{ 'is-invalid': $v.record.doctor.$error }"
                  v-model.trim="record.doctor"
                  class="form-control"
                  @input="$v.record.doctor.$touch()"
                >
                <div v-if="$v.record.doctor.$error">
                  <span
                    v-if="!$v.record.doctor.required"
                    class="help-block help-block-error"
                  >Field is required</span>
                </div>
              </div>
              <div class="form-group">
                <label>License No</label>
                <input
                  :class="{ 'is-invalid': $v.record.license_no.$error }"
                  v-model.trim="record.license_no"
                  class="form-control"
                  @input="$v.record.license_no.$touch()"
                >
                <div v-if="$v.record.license_no.$error">
                  <span
                    v-if="!$v.record.license_no.required"
                    class="help-block help-block-error"
                  >Field is required</span>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>DEA No</label>
                <input v-model.trim="record.dea_no" class="form-control" >
              </div>
              <div class="form-group">
                <label>License State</label>
                <input v-model.trim="record.license_state" class="form-control" >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h3>Account information</h3>
        </div>
        <div class="card-body">
          <div class="form-group custom-control custom-checkbox">
            <input id="active" v-model="record.active" type="checkbox" class="custom-control-input" value="1">
            <label class="custom-control-label" for="active">Active</label>
          </div>
          <div class="form-group">
            <label>Email</label>
            <input
              :class="{ 'is-invalid': $v.record.user.email.$error }"
              v-model.trim="record.user.email"
              class="form-control"
              @input="$v.record.user.email.$touch()"
            >
            <div v-if="$v.record.user.email.$error">
              <span
                v-if="!$v.record.user.email.required"
                class="help-block help-block-error"
              >Field is required</span>
            </div>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input v-model.trim="record.user.password" placeholder="Type to change password" type="password" class="form-control" >
          </div>
          <div class="form-group">
            <label>Password (repeat)</label>
            <input
              :class="{ 'is-invalid': $v.record.user.password_repeat.$error }"
              v-model.trim="record.user.password_repeat"
              type="password"
              class="form-control"
              placeholder="Repeat new password"
              @input="$v.record.user.password_repeat.$touch()"
            >
            <label
              v-if="$v.record.user.password_repeat.$error && !$v.record.user.password_repeat.sameAsPassword"
              class="error"
              for="name"
            >Passwords must be identical.</label>
          </div>
          <div class="form-group">
            <p>* After you'll change password, veterinarian will automatically get the email with new password</p>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Save</button>
        </div>
      </div>
    </form>
    <div v-else class="card">
      <div class="card-header">
        <h3>You have not permission for do that</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { required, sameAs } from 'vuelidate/lib/validators'
import ZipMask from './../../../mixins/ZipMask'

export default {
  name: 'ProfilesEdit',
  mixins: [ZipMask],
  data () {
    return {
      record: {
        user: {}
      }
    }
  },
  validations: {
    record: {
      clinic: {
        required
      },
      doctor: {
        required
      },
      license_no: {
        required
      },
      user: {
        email: {
          required
        },
        password_repeat: {
          sameAsPassword: sameAs('password')
        }
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    let route = '/api/admin/profiles/' + to.params.profileId
    axios
      .get(route)
      .then(repsonse => {
        next(vm => (vm.record = repsonse.data.profile))
      })
      .catch(error => {
        console.log(error)
        next()
      })
  },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  beforeRouteUpdate (to, from, next) {
    console.log('update')
  },
  methods: {
    saveRecord () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios
          .post('/api/admin/profiles/save', {
            profile: this.record
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.profile
              toastr['success']('Changes have been saved successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    goBack () {
      this.$router.push('/admin/profiles')
    }
  }
}
</script>

<style>
</style>
